/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type SbSharedContentModulePromo_browseContentModule$ref = any;
export type SbSharedContentModulePromo_browseContentModule = {
    readonly photo: string | null;
    readonly pillText: string | null;
    readonly headline: string | null;
    readonly subtext: string | null;
    readonly link: string | null;
    readonly linkText: string | null;
    readonly " $refType": SbSharedContentModulePromo_browseContentModule$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedContentModulePromo_browseContentModule",
  "type": "ContentModulePromo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "photo",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pillText",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "headline",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "subtext",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "link",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "linkText",
      "args": null,
      "storageKey": null
    }
  ]
};
(node as any).hash = '3b15e045e642739f08f52ba6aebaf58b';
export default node;
